import _ from 'lodash';

import { ActionStep, CustomIndex } from '@src/clients/seeker/api';
import { IndexAgentResponse } from '@src/clients/seeker/api';
import { AoiMapPrimaryActionsTools, VisualizationStage } from '@src/contexts';
import { For } from '@src/hoc';
import { useGetIndiceById } from '@src/hooks';
import { usePaths } from '@src/hooks/usePaths';

import { ToolCard } from './ToolCard';

const IndiceCard = ({
  indice,
  aoiId
}: {
  indice: CustomIndex;
  aoiId: string;
}) => {
  const { navigateToAoiDetails } = usePaths();

  const { indice: indiceById } = useGetIndiceById({ ids: [indice.id] });

  const indiceData = indiceById?.[0] || {};

  if (_.isEmpty(indiceData)) return;

  const navigateToIndice = () => {
    navigateToAoiDetails({
      aoiId,
      queryParameters: {
        tool: AoiMapPrimaryActionsTools.VISUALIZATION,
        stage: VisualizationStage.DETAILS,
        indiceId: indiceData.id
      }
    });
  };

  return (
    <ToolCard
      showButton
      heading={indiceData?.name}
      subHeading={indiceData?.title || ''}
      src={indiceData?.thumbnail_url || ''}
      buttonClick={navigateToIndice}
    />
  );
};

export const AiIndiceList = ({ step }: { step: ActionStep }) => {
  const toolData = step?.tool_data as IndexAgentResponse;
  const indices = toolData?.indices || [];
  if (_.isEmpty(indices)) return null;

  const aoiId = toolData.aoi_id;

  return (
    <For each={indices}>
      {indice => <IndiceCard indice={indice} aoiId={aoiId} />}
    </For>
  );
};
